<template>
  <div class="outer-wrapper">
    <div
      :id="ids"
      class="chart-wrapper"
      :style="esize"
    ></div>
    <select v-model="period" class="select-period">
      <option value="year">年度统计</option>
      <option value="month">月度统计</option>
      <option value="day">每日统计</option>
    </select>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
export default {
  name: "oneGoodsFlow",
  props: {
    "optionData":{
        type:Object,
        required:false,
        default:function(){
          return {};
        }
    },
    'chart_draw_again':{
      type:Number,
      required:false,
      default:0
    },
    'esize':{
      type:Object,
      required:true,
      default:function(){
        return { height: '430px', width: '700px'};
      }
    },
    'goodsObject':{
        type:Object,
        required:true,
        default:function(){
          return {};
        }
    },

  },
  data() {
    return {
        ids:this.$options.name,
        originData: {},
        period: "day",
    };
  },
  created() {
      
  },
  mixins: [],
  watch: {
    chart_draw_again: function (val) {
      if (val > 0) {
        this.get_data();
      }
    },
    period() {
      this.drawIt();
    },
  },
  computed: {
    chartData:function(){
        return this.originData[this.period];
    },
    periodText: function () {
      if (this.period === "year") {
        return "每年";
      } else if (this.period === "month") {
        return "每月";
      } else if (this.period === "day") {
        return "每日";
      } else {
        return "";
      }
    },
  },
  methods: {
    get_data() {
      this.$axios
        .post(this.$url + "/chartdata", {
          askData: this.$options.name,
          optionData: this.optionData,
          userToken: userToken,
          goodsId:this.goodsObject.id
        })
        .then((response) => {
            if(response.data.stat==='ok'){
                this.originData = response.data.res;
                this.drawIt();
            }else{
                console.log('获取数据失败！');
            }
        });
    },
    drawIt() {
      let myChart = this.$echarts.init(document.getElementById(this.ids));
      let timeData = this.chartData.timeData;
      let dataIn = this.chartData.dataIn;
      let dataOut = this.chartData.dataOut;
      let dataRest = this.chartData.dataRest;
      let option = {
        backgroundColor: "#e0fffa",
        title: {
          text: this.periodText + "出入库数量统计",
          subtext: this.goodsObject.name,
          left: "center",
          top: "5%",
          textStyle: {
            color: "#888",
            verticalAlign: "top",
          },
        },
        legend: {
          data: ["入库", "出库", "净值"],
          right: '2%',
          bottom:'3%'
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          x: "10%",
          y: "25%",
          x2: "10%",
          y2: "25%",
          borderWidth: 10,
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        calculable: true,
        xAxis: {
          data: timeData,
          name: "时间",
          type: "category",
          boundaryGap:true,
          axisTick: { show: true,alignWithLabel:true,interval:0},
          axisLine: { onZero: false },
          splitLine: { show: false },
          splitArea: { show: false },
        },
        yAxis: [
          {
            type: "value",
            name: "数量("+this.goodsObject.pit+')',
            splitArea: { show: false },
            max: function (value) {
                return Math.ceil(value.max*0.11)*10;
            },
            min: function (value) {
                return Math.floor(value.min*0.11)*10;
            },
          },
        ],
        visualMap: {
          type: "continuous",
          dimension: 1,
          text: ["入库", "出库"],
          itemHeight: 200,
          calculable: true,
          orient:'horizontal',
          inverse:true,
          min: Math.min(...dataOut),
          max: Math.max(...dataIn),
          bottom: '3%',
          left: '3%',
          inRange: {
            colorLightness: [0.4, 0.8],
          },
          outOfRange: {
            color: "#bbb",
          },
          controller: {
            inRange: {
              color: ['green','red'],
            },
          },
        },
        series: [
          {
            name: "入库",
            type: "bar",
            stack: "one",
            label:{
              show:true,
              position:'top'
            },
            data: dataIn,
            barWidth: "33%",
            itemStyle:{
                color:'red',
            }
          },
          {
            name: "出库",
            type: "bar",
            stack: "one",
            label:{
              show:true,
              position:'bottom'
            },
            data: dataOut,
            barWidth: "33%",
            itemStyle:{
                color:'green',
            }
          },
          {
            name: "净值",
            type: "line",
            data: dataRest,
            itemStyle:{
                color:'#4082fd',
            }
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>
<style scoped>
.outer-wrapper {
  margin: 0;
  position: relative;
  width:100%;
}
.chart-wrapper {
  border: 1px solid #eeeded;
  border-radius: 3px;
  margin: 0 auto;
}
.select-period {
  position: absolute;
  top: 2px;
  right: 2px;
  height: 30px;
  font-size: 14px;
  padding: 0 14px;
  color: 999;
}
</style>